import { ContactInfo } from '../users/dto/contact-info';
import { Deserializable } from '../protocols/deserializable';

export class ContactInfoChangeSubmission implements Deserializable {
  public previous!: ContactInfo;
  public new!: ContactInfo;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize?.instanceOf(ContactInfo, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize?.instanceOf(ContactInfo, this.new);
    }
  }
}
